<template>
    <div class="form__page">
        <b-card class="login-card"
                header-tag="header"
                footer-tag="footer"
                sub-title="Please enter your email and password">
            <h4 slot="header" class="mb-0">PB Shop Admin Login</h4>
            <b-card-text>
                <b-form @submit.prevent="checkLoginCredentials">
                    <div class="form-group">
                        <b-form-input
                                class="form__input mb-2"
                                type="text"
                                placeholder="Username"
                                v-model="username"
                                @input="hideLoginFailAlert"
                        ></b-form-input>
                    </div>
                    <!-- should be @focus instead of @input, but it did not work  -->
                    <div class="form-group">
                        <b-form-input
                                class="form__input mb-2"
                                type="password"
                                placeholder="Password"
                                v-model="password"
                                @input="hideLoginFailAlert"
                        ></b-form-input>
                    </div>
                    <div class="form-group">
                        <pb-btn :busy="loadingUser" type="submit"
                                icon="fa-arrow-right fa-sm">
                            SIGN IN
                        </pb-btn>
                    </div>

                </b-form>
                <!--<div>-->
                <!--<b-link class="form__link login__link&#45;&#45;forgot" href="#TODO">Forgot Password?</b-link>-->
                <!--</div>-->
                <!--<div v-if="showSignUp">-->
                <!--<b-link class="form__link" :href="signupLink">Sign up</b-link>-->
                <!--</div>-->
                <div v-if="submitted" class="login__spinning"></div>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {mapState, mapActions} from "vuex";

    export default {
        name: "Login",
        data() {
            return {
                username: "",
                password: "",
                submitted: false, // TODO,
                signupLink: "/#/signup",
                loginFailText: "Invalid username and password"
            };
        },
        props: {
            title: {
                type: String,
                required: true
            },
            showSignUp: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState("account", ["status", "loadingUser"]),
            ...mapState("account", ["showLoginFailAlert"])
        },
        methods: {
            ...mapActions("account", ["login", "logout", "resetUser", "hideLoginFailAlert"]),
            checkLoginCredentials() {
                this.submitted = true;
                const {username, password} = this; // TODO
                this.$emit("login", {username, password, path: this.$route.path});
                this.password = "";
                // if (username && password) {
                //     this.login({ username, password })
                // }
                // tODO
            }
        }
    };
</script>

<style ang="scss" scoped>
    .login-card {
        max-width: 360px;
        margin: 7% auto;
    }
</style>